import { useEffect, useState, useRef } from "react";

interface EngagementData {
  scrollPercentage: number;
  // timeSpent: number; // setInterval 비활성화로 항상 0
}

interface EngagementConfig {
  lowScrollThreshold: number; // 25
  highScrollThreshold: number; // 50
  // lowTimeThreshold: number; // setInterval 비활성화로 미사용
  // highTimeThreshold: number; // setInterval 비활성화로 미사용
  baseHref: string; // "/registration/info/"
  trustPageHref: string; // "/registration/info-trust"
  verificationHref: string; // "/registration/verification/?productGroup=..."
}

export const useEngagementTracking = (config?: Partial<EngagementConfig>) => {
  const defaultConfig: EngagementConfig = {
    lowScrollThreshold: 25,
    highScrollThreshold: 50,
    // lowTimeThreshold: 5,
    // highTimeThreshold: 20,
    baseHref: "/registration/info/",
    trustPageHref: "/registration/info",
    verificationHref: "/registration/verification/?productGroup=100",
  };

  const finalConfig = { ...defaultConfig, ...config };
  const [engagementData, setEngagementData] = useState<EngagementData>({
    scrollPercentage: 0,
    // timeSpent: 0,
  });

  // const startTimeRef = useRef<number>(Date.now());
  const scrollTimeoutRef = useRef<NodeJS.Timeout>();

  // 스크롤 진행률 계산
  const updateScrollPercentage = () => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const scrollHeight =
      document.documentElement.scrollHeight - window.innerHeight;
    const percentage = Math.round((scrollTop / scrollHeight) * 100);

    setEngagementData((prev) => ({
      ...prev,
      scrollPercentage: Math.max(prev.scrollPercentage, percentage),
    }));
  };

  // 체류시간 업데이트 — setInterval 비활성화로 미사용
  // const updateTimeSpent = () => {
  //   const timeSpent = Math.round((Date.now() - startTimeRef.current) / 1000);
  //   setEngagementData((prev) => ({
  //     ...prev,
  //     timeSpent,
  //   }));
  // };

  useEffect(() => {
    // 스크롤 이벤트 리스너
    const handleScroll = () => {
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
      }

      scrollTimeoutRef.current = setTimeout(() => {
        updateScrollPercentage();
      }, 100); // 디바운싱
    };

    // 체류시간 업데이트 (1초마다)
    // const timeInterval = setInterval(updateTimeSpent, 1000);

    window.addEventListener("scroll", handleScroll, { passive: true });

    // 초기 스크롤 위치 설정
    updateScrollPercentage();

    return () => {
      window.removeEventListener("scroll", handleScroll);
      // clearInterval(timeInterval);
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
      }
    };
  }, []);

  // href 결정 로직 (현재 스크롤 기반만 동작 — 시간 조건은 setInterval 비활성화로 주석)
  const getHrefByEngagement = () => {
    const { scrollPercentage } = engagementData;
    // const { scrollPercentage, timeSpent } = engagementData;
    const {
      lowScrollThreshold,
      highScrollThreshold,
      // lowTimeThreshold,
      // highTimeThreshold,
      baseHref,
      trustPageHref,
      verificationHref,
    } = finalConfig;

    // 조건 3: 스크롤 highScrollThreshold% 이상
    if (
      scrollPercentage >= highScrollThreshold
      // || timeSpent >= highTimeThreshold
    ) {
      return verificationHref;
    }

    // 조건 2: 스크롤 lowScrollThreshold% 이상 ~ highScrollThreshold% 미만
    if (
      scrollPercentage >= lowScrollThreshold &&
      scrollPercentage < highScrollThreshold
      // || (timeSpent >= lowTimeThreshold && timeSpent < highTimeThreshold)
    ) {
      return trustPageHref;
    }

    // 조건 1: 스크롤 lowScrollThreshold% 미만
    return baseHref;
  };

  return {
    engagementData,
    getHrefByEngagement,
  };
};
